import { GetSpareStockDto, GetSpareStockReqDto, NameAndDescReqDto } from "@gtpl/shared-models/asset-management";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { Like } from "typeorm";
import { SpareStockCreateDto } from "./dto/spare-stock-create.dto";
import { SpareStockRepository } from "./repositories/spare-stock-repo";
import { SpareStockAdapter } from "./spare-stock-adapter";
import fs from 'fs'
import * as XLSX from 'xlsx';
const fileDirectory = __dirname.replace(/\\dist/, '')
import path, { extname } from 'path'
import { ExtractedDataDto } from "./dto/extract-data-interface";
import moment from "moment";
@Injectable()
export class SpareStockService {

    constructor(
        private adapter: SpareStockAdapter,
        private repo: SpareStockRepository
    ) {

    }

    async createSpareStocksTesting(file, req: any): Promise<CommonResponse> {
        const transactionManger = new GenericTransactionManager();
        const readingFilePath = path.join(fileDirectory, 'upload-files', file.path.replace(path.join(fileDirectory, 'upload-files'), ''));
        try {
            await transactionManger.startTransaction();
            //blob
            const data = fs.readFileSync(readingFilePath)

            const workbook = XLSX.read(data, { type: 'array', cellDates: true });
            // console.log(workbook,"workbook")
            const workBookSheetNames = workbook.SheetNames;
            let savingReq: any[] = [];
            for (const sheets of workBookSheetNames) {
                const worksheet = workbook.Sheets[sheets];
                const excelData = XLSX.utils.sheet_to_json(worksheet, { raw: true, header: 1 });
                console.log(excelData[3], "excelDataexcelDataexcelData")
                const warehouse: any = Object.values(excelData[0])[0]
                const stockZone: any = Object.values(excelData[0])[0]
                const constructedData = excelData.slice(3).map((rec: ExtractedDataDto) => {
                    const receipt = rec.__EMPTY_15.split('/')
                    const receiptDate = new Date(parseInt(20 + receipt[2], 10), parseInt(receipt[1], 10) - 1, parseInt(receipt[0], 10))
                    //rec.__EMPTY_15.replace(/\//g, "-")
                    return new GetSpareStockDto(Object.values(rec)[0], rec.__EMPTY, rec.__EMPTY_1, rec.__EMPTY_2, rec.__EMPTY_3, rec.__EMPTY_4, rec.__EMPTY_5, rec.__EMPTY_6, rec.__EMPTY_7, rec.__EMPTY_8, rec.__EMPTY_9, rec.__EMPTY_10, rec.__EMPTY_11, rec.__EMPTY_12, rec.__EMPTY_13, rec.__EMPTY_14, moment(receiptDate).format('DD-MM-YYYY'), rec.__EMPTY_16, rec.__EMPTY_17, rec.__EMPTY_18, rec.__EMPTY_19, rec.__EMPTY_20, rec.__EMPTY_21 === 'null-null' ? null : rec.__EMPTY_21.replace(/\s{2,}/g, ' '), rec.__EMPTY_22, req.status, req.id, warehouse.split(':')[1], req.userName, "upload-files" + file.path.replace(path.join(fileDirectory, 'upload-files'), ''), stockZone.split(' ')[28].split(':')[1])
                })
                savingReq.push(...constructedData);
            };
            const convertDtoToEntity = this.adapter.convertDtoToEntity(savingReq);
            await transactionManger.getCustomRepository(SpareStockRepository).save(convertDtoToEntity)
            await transactionManger.completeTransaction();
            return new CommonResponse(true, 23245, "Spare Parts Created Successfully")
        } catch (error) {
            await transactionManger.releaseTransaction();
            if (fs.existsSync(readingFilePath)) {
                fs.unlinkSync(readingFilePath)
            }
            console.log(error)
            throw error
        }
        // 1190 +575

    };



    async createSpareStock(file, req: any): Promise<CommonResponse> {
        const transactionManger = new GenericTransactionManager();
        const readingFilePath = path.join(fileDirectory, 'upload-files', file.path.replace(path.join(fileDirectory, 'upload-files'), ''));
        try {
            await transactionManger.startTransaction();
            // Read the file
            const data = fs.readFileSync(readingFilePath);
            const workbook = XLSX.read(data, { type: 'array', cellDates: true });
            const workBookSheetNames = workbook.SheetNames;
            let savingReq: any[] = [];
            for (const sheets of workBookSheetNames) {
                const worksheet = workbook.Sheets[sheets];
                const excelData: any = XLSX.utils.sheet_to_json(worksheet, { raw: false, header: 1 });
                const headers = excelData[3].map((rec) => { return rec.replace(/[\s~`!@#$%^&*(){}\[\];:"'<,.>?\/\\|_+=-]/g, '').toLowerCase(); });
                const staticMap = new Map<string, number>();
                for (const [index, head] of headers.entries()) {
                    staticMap.set(head, index);
                }
                excelData.slice(4).forEach((rec, index) => {
                    const obj = new GetSpareStockDto('', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 0, '', 0, 0, 0, '', '', undefined, 0, 0, '', '', '');
                    const dtoClassKeys = Object.keys(obj).map((rec) => { return rec.toLowerCase(); });
                    for (const classKeys of dtoClassKeys) {
                        const value = rec[staticMap.get(classKeys)];
                        if (classKeys === "reciept" && value) {
                            const receipt = value.split('/');
                            if (receipt.length === 3) {
                                const receiptDate = new Date(parseInt('20' + receipt[2], 10), parseInt(receipt[1], 10) - 1, parseInt(receipt[0], 10));
                                obj[classKeys] = moment(receiptDate).format('DD-MM-YYYY');
                            } else {
                                obj[classKeys] = null;
                            }
                        } else if (classKeys === "warehouse") {
                            obj[classKeys] = Number(sheets.match(/(\d+)/)[0]);
                        } else if (classKeys === "filepath") {
                            obj[classKeys] = "upload-files" + file.path.replace(path.join(fileDirectory, 'upload-files'), '');
                        } else if (classKeys === 'stockzone') {
                            const stockZoneValue = excelData[1][0]?.split(' ')[28]?.split(':')[1];
                            obj[classKeys] = stockZoneValue ? stockZoneValue : null;
                        } else if (classKeys === 'supplier') {
                            obj[classKeys] = value === "null-null" ? null : value?.replace(/\s{2,}/g, ' ');
                        } else {
                            obj[classKeys] = value;
                        }
                    }
                    savingReq.push(obj);
                });
            }
            const convertDtoToEntity = this.adapter.convertDtoToEntity(savingReq);
            await transactionManger.getCustomRepository(SpareStockRepository).save(convertDtoToEntity);
            await transactionManger.completeTransaction();
            return new CommonResponse(true, 23245, "Spare Parts Created Successfully");
        } catch (error) {
            await transactionManger.releaseTransaction();
            if (fs.existsSync(readingFilePath)) {
                fs.unlinkSync(readingFilePath);
            }
            console.log(error);
            throw error;
        }
    }
    





    async getSpareStockDataAgainstToNameAndDesc(req: NameAndDescReqDto): Promise<CommonResponse> {
        let repoData;
        if (req.name || req.description || req.item) {
            repoData = await this.repo.find({ where: [{ name: Like(`%${req.name}%`) }, { description: Like(`%${req.description}%`) }, { itemNumber: Like(`%${req.item}%`) }] })
        } else {
            repoData = await this.repo.find();
        }
        if (!repoData.length) {
            return new CommonResponse(false, 31256, "Data Not Found", [])
        } else {
            return new CommonResponse(true, 65213, "Data Retrieved Successfully", repoData)
        }
    }


    async getSpareStockData(req: GetSpareStockReqDto): Promise<CommonResponse> {
        let repoData;
        if (req.location || req.locationDescription && req.stockZone || req.warehouse) {
            repoData = await this.repo.getSpareStockData(req);
        } else {
            repoData = await this.repo.find({ where: { stockZone: req.stockZone, warehouse: req.warehouse } });
        }
        if (!repoData.length) {
            return new CommonResponse(false, 87456, "Data Not Found", [])
        } else {
            return new CommonResponse(true, 65478, "Data Retrieved Successfully", repoData)
        }
    }


}